<template>
  <section class="bg-[url('@/assets/background/bgrotatedv2.svg')] bg-no-repeat bg-cover">
    <div class="md:px-36 py-7 md:py-40 md:bg-[url('@/assets/background/strippedv2.svg')] bg-no-repeat bg-contain bg-bottom">
      <div class="grid grid-cols-2 gap-10">
        <div class="col-span-2 md:col-span-1 flex items-center">
          <div class="space-y-4 p-7">
            <div class="text-biru text-4xl">{{ $t("message.tender") }}</div>
            <div class="text-abumaluku">{{ $t("message.tender_desc") }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-20 px-7 md:px-36 space-y-7">
    <div class="grid grid-cols-2 gap-4">
      <div v-for="(item, id) in pagination.paginatedData" :key="id" class="bg-white shadow-btn-download p-4 col-span-2 md:col-span-1 space-y-2 flex flex-col justify-between">
        <div class="space-y-1">
          <h1 class="text-biru font-semibold">{{ $i18n.locale == 'id' ? (item.judul.length > 100 ? `${item.judul.substring(0, 100)}...` : item.judul) : item.judul_en.length > 100 ? `${item.judul_en.substring(0, 100)}...` : item.judul_en }}</h1>
          <h1 class="text-xs text-abucms">
            {{
              $i18n.locale == "id"
                ? new Intl.DateTimeFormat("id", {
                    dateStyle: "full",
                  }).format(new Date(item.tgl_posting))
                : new Intl.DateTimeFormat("en-US", {
                    dateStyle: "full",
                  }).format(new Date(item.tgl_posting))
            }}
          </h1>
        </div>
        <div class="space-y-2">
          <div class="border border-1 border-t-0 w-full border-abumaluku/10"></div>
          <div class="flex space-x-2">
            <router-link :to="{ name: 'landingpagetenderdetail', params: { id: item.id } }">
              <button class="hover:scale-105 ease-in-out duration-200 button-primary text-xs px-3">{{ $t("message.lihat") }}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Paginator v-if="pagination?.data?.length > 0" :rows="6" :totalRecords="pagination.data.length" @page="toPage($event)"></Paginator>
  </section>
</template>

<script>
import { ref } from "@vue/reactivity";
import handlePagination from "@/views/components/handlePagination";
import Paginator from "primevue/paginator";
import { onMounted, watch } from "@vue/runtime-core";
import { getPengadaan } from "@/api/LandingPageApi";
import Empty from "@/views/landingpage/Empty.vue";
export default {
  components: { Paginator, Empty },
  setup() {
    const pagination = ref({});
    const cari = ref("");
    const items = ref([]);
    const filteredItems = ref([]);

    const toPage = (event) => {
      pagination.value.goToPage(event.page + 1);
    };

    watch(cari, (newCari) => {
      filteredItems.value = items.value.filter((item) => {
        return item.judul.toLowerCase().includes(cari.value.toLowerCase()) || item.kategori.toLowerCase().includes(cari.value.toLowerCase());
      });
    });

    watch(filteredItems, (newItems) => {
      pagination.value = { ...handlePagination(filteredItems.value) };
    });

    onMounted(async () => {
      getData();
    });

    const getData = async () => {
      const result = await getPengadaan();
      if (result?.data?.data) {
        items.value = result?.data?.data.filter((e) => new Date(e.tgl_posting) <= new Date());
        filteredItems.value = result?.data?.data.filter((e) => new Date(e.tgl_posting) <= new Date());
      }
    };

    return { toPage, pagination, cari, getData };
  },
};
</script>
<style></style>
